import { render, staticRenderFns } from "./no-data-block.vue?vue&type=template&id=56c0ecaa&scoped=true&"
import script from "./no-data-block.vue?vue&type=script&lang=ts&"
export * from "./no-data-block.vue?vue&type=script&lang=ts&"
import style0 from "./no-data-block.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./no-data-block.vue?vue&type=style&index=1&id=56c0ecaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c0ecaa",
  null
  
)

export default component.exports